import React, {useContext, useEffect, useState} from "react";
import {useIsMobileDevice} from "../../../../hooks/useIsMobileDevice";
import {useIsProduction} from "../../../../hooks/useIsProduction";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";
import {ThemeContext} from "../../../../context/ThemeContext";
import {Theme} from "../../../../models/theme.model";
import "./CardconnectCreditCardInput.scss";
import {convertHexColorToRGB} from "../../../../utils/util-functions";
import {useIsTabletDevice} from "../../../../hooks/useIsTabletDevice";

/* eslint import/no-webpack-loader-syntax: off */

interface CardconnectCreditCardInputProps {
    onSetCreditCardNumber: (creditCardNumber: string) => void;
    onSetIsCreditCardNumber: (isCreditCardNumberValid: boolean) => void;
}

export const CardconnectCreditCardInput: React.FunctionComponent<CardconnectCreditCardInputProps> = (props) => {
    const theme: Theme = useContext(ThemeContext).theme;
    const devCardConnectUrl: string = 'https://fts-uat.cardconnect.com';
    const prodCardConnectUrl: string = 'https://fts.cardconnect.com';
    const isMobileDevice = useIsMobileDevice(false);
    const isMobileDeviceByWidth = useIsMobileDevice(true);
    const isTabletDevice = useIsTabletDevice();
    const isProduction = useIsProduction();
    const iframeStyles = require('!!css-loader!./CardconnectIframe.css');
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const invalidCardNumberError = 'Invalid Card Number.';

    const getCardConnectPath = () => {
        if(isProduction) {
            return prodCardConnectUrl;
        } else {
            return devCardConnectUrl;
        }
    }

    const onCardconnectTokenChanged = (event: MessageEvent) => {
        try {
            let eventData = JSON.parse(event.data);
            if (eventData['message']) {
                props.onSetCreditCardNumber(eventData['message']);
                props.onSetIsCreditCardNumber(true);
                setErrors([]);
            } else {
                props.onSetCreditCardNumber('');
                props.onSetIsCreditCardNumber(false);
                setErrors([invalidCardNumberError]);
            }
        } catch {
        }
    }

    useEffect(() => {
        window.addEventListener('message', onCardconnectTokenChanged, false);
        return () => {
            window.removeEventListener('message', onCardconnectTokenChanged, false);
        }
    }, [false]);

    const getCardconnectIframePathWithStyles = () => {
        return `${getCardConnectPath()}/itoke/ajax-tokenizer.html?invalidinputevent=true&tokenizewheninactive=${isMobileDevice}&css=${getIframeStyles()}`;
    }

    const getIframeStyles = () => {
        let iframeStylesString = String(iframeStyles.default);
        const RGBBrandingColor = convertHexColorToRGB(theme.branding_color);
        const RGBBrandingColorString = `rgb(${RGBBrandingColor[0]}, ${RGBBrandingColor[1]}, ${RGBBrandingColor[2]})`;

        if (isMobileDeviceByWidth || isTabletDevice) {
            iframeStylesString = iframeStylesString.replace('1rem', '1.2rem');
        } else {
            iframeStylesString = iframeStylesString.replace('1.2rem', '1rem');
        }

        iframeStylesString = encodeURI(iframeStylesString.replace('black', RGBBrandingColorString));

        return iframeStylesString;
    };

    return <div>
        <iframe id="cardconnect-input" frameBorder="0" src={getCardconnectIframePathWithStyles()}/>
        {errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
